import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 -20 485 485",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_4",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,225.501,251.95)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0,-3.947C-0.823,-13.739 -4.205,-22.737 -9.523,-29.286C-13.526,-34.215 -20.636,-40.09 -31.781,-40.09C-33.038,-40.09 -34.337,-40.015 -35.642,-39.867C-43.518,-38.974 -49.933,-35.088 -54.708,-28.314C-59.098,-22.086 -61.743,-13.711 -62.156,-4.733C-62.922,11.921 -55.691,31.518 -38.005,35.191C-34.961,35.823 -32.02,36.143 -29.265,36.143C-20.976,36.143 -14.172,33.315 -9.044,27.737C-2.328,20.434 1.053,8.589 0,-3.947",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0,-1,-1,0,250.788,288.868)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-27.871,-12.82C-16.635,-12.82 0,-3.711 0,7.525C0,18.762 -16.635,27.871 -27.871,27.871C-39.107,27.871 -40.691,18.762 -40.691,7.525C-40.691,-3.711 -39.107,-12.82 -27.871,-12.82",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,236.902,384.186)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0,35.673L0,0C0,-7.097 -5.774,-12.871 -12.871,-12.871C-19.968,-12.871 -25.741,-7.097 -25.741,0L-25.741,35.673C-25.741,42.77 -19.968,48.544 -12.871,48.544C-5.774,48.544 0,42.77 0,35.673",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,249.622,384.186)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0,35.673C0,42.77 5.774,48.544 12.871,48.544C19.968,48.544 25.741,42.77 25.741,35.673L25.741,0C25.741,-7.097 19.968,-12.871 12.871,-12.871C5.774,-12.871 0,-7.097 0,0L0,35.673Z",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,323.18,252.737)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0,-5.519C-0.413,-14.498 -3.058,-22.873 -7.448,-29.1C-12.223,-35.874 -18.637,-39.761 -26.512,-40.653C-27.818,-40.801 -29.117,-40.876 -30.374,-40.876C-38.699,-40.876 -45.791,-37.705 -51.453,-31.449C-56.608,-25.755 -60.235,-17.69 -61.668,-8.739C-63.803,4.599 -60.788,17.976 -53.8,26.172C-48.602,32.267 -41.568,35.357 -32.89,35.357C-30.135,35.357 -27.194,35.037 -24.15,34.404C-6.464,30.731 0.766,11.135 0,-5.519",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1,0,0,1,351.175,279.383)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M0,-108.34C-13.602,-126.369 -31.066,-139.677 -51.905,-147.896L-54.032,-148.735L-53.781,-151.007C-51.368,-172.909 -41.864,-193.126 -27.021,-207.933C-11.972,-222.946 7.424,-231.214 27.595,-231.214C72.817,-231.214 109.607,-190.206 109.607,-139.802C109.607,-115.785 101.285,-93.089 86.174,-75.894C78.801,-67.505 70.197,-60.86 60.601,-56.143C50.651,-51.253 40.063,-48.658 29.132,-48.432L26.714,-48.382L26.159,-50.736C20.933,-72.88 12.132,-92.26 0,-108.34M-163.919,-147.896C-184.759,-139.677 -202.223,-126.369 -215.826,-108.34C-227.958,-92.26 -236.759,-72.88 -241.984,-50.736L-242.54,-48.382L-244.958,-48.432C-255.889,-48.659 -266.477,-51.253 -276.427,-56.144C-286.024,-60.861 -294.628,-67.506 -302.001,-75.895C-317.112,-93.089 -325.434,-115.785 -325.434,-139.802C-325.434,-190.206 -288.642,-231.214 -243.419,-231.214C-223.249,-231.214 -203.852,-222.946 -188.803,-207.933C-173.96,-193.126 -164.456,-172.909 -162.043,-151.007L-161.792,-148.735L-163.919,-147.896ZM-26.086,71.144C-15.665,64.596 -1.397,55.631 10.489,43.046C16.924,36.232 21.931,29.058 25.371,21.724C29.367,13.204 31.393,4.161 31.393,-5.152C31.393,-9.828 31.215,-14.706 30.864,-19.648L30.65,-22.663L33.667,-22.846C61.07,-24.51 86.636,-37.398 105.655,-59.136C124.803,-81.023 135.348,-109.67 135.348,-139.802C135.348,-204.4 87.01,-256.955 27.595,-256.955C14.52,-256.955 1.736,-254.424 -10.401,-249.432C-22.139,-244.605 -32.945,-237.622 -42.519,-228.678C-61.887,-210.585 -74.766,-185.637 -78.783,-158.433L-79.221,-155.466L-82.187,-155.912C-90.512,-157.163 -99.167,-157.797 -107.912,-157.797C-116.656,-157.797 -125.311,-157.163 -133.637,-155.912L-136.603,-155.466L-137.041,-158.433C-141.059,-185.638 -153.937,-210.585 -173.305,-228.678C-182.879,-237.622 -193.685,-244.605 -205.423,-249.432C-217.56,-254.424 -230.344,-256.955 -243.419,-256.955C-302.836,-256.955 -351.175,-204.4 -351.175,-139.802C-351.175,-109.671 -340.63,-81.024 -321.481,-59.137C-302.462,-37.399 -276.896,-24.511 -249.494,-22.846L-246.476,-22.663L-246.691,-19.648C-247.042,-14.706 -247.22,-9.829 -247.22,-5.152C-247.22,4.162 -245.194,13.204 -241.198,21.725C-237.758,29.059 -232.751,36.233 -226.316,43.047C-214.427,55.634 -200.161,64.597 -189.745,71.14L-189.634,71.21C-186.531,73.161 -183.015,75.373 -181.646,76.42L-181.142,76.806L-180.838,77.362C-177.664,83.174 -178.147,97.438 -178.37,101.672C-178.974,113.092 -181.026,123.979 -183.862,130.795C-185.182,133.969 -185.187,137.468 -183.876,140.647C-182.565,143.826 -180.096,146.303 -176.922,147.623C-175.341,148.281 -173.681,148.614 -171.986,148.614C-166.769,148.614 -162.1,145.5 -160.093,140.681C-156.82,132.812 -153.062,116.545 -152.546,99.431C-152.276,90.474 -152.929,82.521 -154.485,75.791C-156.222,68.28 -159.046,62.53 -162.878,58.699C-165.767,55.806 -170.08,53.097 -176.048,49.347C-193.04,38.67 -221.479,20.802 -221.479,-5.152C-221.479,-32.203 -216.79,-55.481 -207.544,-74.336C-199.754,-90.22 -188.674,-103.127 -174.61,-112.697C-163.64,-120.163 -150.918,-125.577 -136.796,-128.789C-124.923,-131.489 -114.535,-132.056 -107.912,-132.056C-101.289,-132.056 -90.901,-131.489 -79.028,-128.789C-64.907,-125.577 -52.185,-120.163 -41.215,-112.697C-27.152,-103.127 -16.072,-90.22 -8.283,-74.336C0.964,-55.481 5.652,-32.203 5.652,-5.152C5.652,20.8 -22.784,38.669 -39.773,49.346C-45.741,53.093 -50.048,55.798 -52.953,58.699C-56.783,62.531 -59.606,68.282 -61.343,75.793C-62.899,82.523 -63.551,90.477 -63.281,99.433C-62.765,116.548 -59.007,132.813 -55.733,140.683C-53.727,145.501 -49.06,148.615 -43.844,148.615C-42.15,148.615 -40.488,148.281 -38.905,147.623C-32.353,144.898 -29.239,137.348 -31.965,130.795C-38.4,115.331 -39.302,85.329 -35.034,77.426L-34.73,76.865L-34.224,76.476C-32.686,75.294 -29.25,73.133 -26.217,71.226L-26.086,71.144Z",
					style: {
						fill: "currentColor",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: 1
					}
				})
			})
		]
	})
});
export default SvgLogo;
